import { IgTextField } from "@intelligems/ig-theme";
import { ExpressionNodeQueryType } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import type { UpdateExpressionNodeQueryType } from "./utils";

interface ConditionValueProps {
  tempExpressionQuery: ExpressionNodeQueryType;
  onChange: UpdateExpressionNodeQueryType;
}

export const ConditionTextKey = ({
  tempExpressionQuery,
  onChange,
}: ConditionValueProps) => {
  return (
    <Grid item>
      <IgTextField
        fullWidth={true}
        value={tempExpressionQuery.key || ""}
        onChange={(e) => {
          onChange(e.target.value || "", "key");
        }}
      />
    </Grid>
  );
};
